import { render, staticRenderFns } from "./PilotLoadoutBlock.vue?vue&type=template&id=2be03fff&"
import script from "./PilotLoadoutBlock.vue?vue&type=script&lang=ts&"
export * from "./PilotLoadoutBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports